var scope_0 = require('/home/runner/work/fastly-docs/fastly-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/38214d6883d94d811188d3cdeec518c5.js').default;
var scope_1 = require('/home/runner/work/fastly-docs/fastly-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d76e8bd4183cc538e2585adc97d42251.js').default;
var scope_2 = require('/home/runner/work/fastly-docs/fastly-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    